var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cloud_svg__a)",
    d: "M34.25 47.75v-13.5h7.078a.9.9 0 0 0 .692-1.476L32.69 21.58a.9.9 0 0 0-1.382 0L21.98 32.774a.9.9 0 0 0 .692 1.476h7.078v13.5H18.5v-.112c-.378.022-.738.112-1.125.112A16.875 16.875 0 0 1 .5 30.875c0-8.658 6.548-15.714 14.949-16.681A16.86 16.86 0 0 1 32 .5a16.866 16.866 0 0 1 16.556 13.694c8.401.967 14.94 8.023 14.94 16.681A16.875 16.875 0 0 1 46.62 47.75c-.377 0-.742-.09-1.124-.112v.112z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud_svg__a",
    x1: 31.998,
    x2: 31.998,
    y1: 0.5,
    y2: 47.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BB0ED"
  })))));
};
export default SvgCloud;